import { MediaPlaceholder, MediaPlaceholderSize } from "client/Components";
import { ReactElement } from "react";
import styles from "./Thumbnail.module.less";

export type ThumbnailProps = {
	imageUrl: string | null;
	mediaPlaceholderSize?: MediaPlaceholderSize;
};

export const Thumbnail = (props: ThumbnailProps): ReactElement => {
	const {
		imageUrl,
		mediaPlaceholderSize
	} = props;

	return (
		<>
			{imageUrl
				? (
					<img
						src={imageUrl}
						className={styles.image}
					/>
				)
				: (
					<MediaPlaceholder
						icon="book"
						size={mediaPlaceholderSize}
					/>
				)
			}
		</>
	);
};
Thumbnail.displayName = "Thumbnail";